import React, { createContext, ReactNode, useContext } from 'react';
import { IEventsContext } from './types';
import { JBEvent } from './events';

export const EventsContext = createContext<IEventsContext>({
  eventHandlers: [],
  postEvent: () => {},
});

export const EventsProvider = ({
  children,
  eventHandlers,
}: Omit<IEventsContext, 'postEvent'> & { children: ReactNode }) => {
  const postEvent = (event: JBEvent) => {
    for (const handler of eventHandlers) {
      const relevantHandler = handler[event.name] as ((data: JBEvent['data']) => void) | undefined;
      if (relevantHandler) {
        relevantHandler(event.data);
      }
    }
  };
  return <EventsContext.Provider value={{ eventHandlers, postEvent }}>{children}</EventsContext.Provider>;
};

export const useEventsContext = (): Omit<IEventsContext, 'eventHandlers'> => {
  const context = useContext(EventsContext);

  if (!context) {
    throw new Error('useEventsContext must be used within an EventsProvider');
  }

  return { postEvent: context.postEvent };
};
